<template>
  <div class="error-modal-container d-flex flex-column align-center text-center">
    <v-icon size="70" class="mb-6" icon="$warning" data-testid="error-modal-icon"></v-icon>
    <div
      class="headline6 text-center px-6 text-pre-wrap word-break-break-word"
      data-testid="error-modal-message"
    >
      <template v-if="te(`errors.${config.item}`)">{{ $t(`errors.${config.item}`) }}</template>
      <template v-else>{{ config.item }}</template>
    </div>
    <v-btn
      color="primary"
      class="mt-7"
      rounded
      size="large"
      data-testid="error-modal-confirm-button"
      @click="$emit('dismissed')"
    >
      {{ $t("general.gotIt") }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { useI18n } from "vue-i18n";
import { defineComponent, type PropType } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module.ts";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  setup() {
    const i18n = useI18n();

    return {
      te: i18n.te,
    };
  },
});
</script>

<style lang="scss" scoped>
.error-modal-container {
  min-height: 300px;
}
</style>
